import { Namespace } from "@smart/itops-types-basic";
import { Env, Region } from "@smart/itops-utils-basic";

export type ZoneDef<Z extends string> = {
  namespace: Namespace<string, Z>;
  domains: Record<Env, Record<Region, string>>;
};

export const buildZoneDef = <Z extends string>(def: ZoneDef<Z>) => def;
